import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';

function Form() {
  const [inactiveSubmission, setInactiveSubmission] = useState(true);
  const [formContact, setFormContact] = useState({
    name: '',
    email: '',
    message: ''
  });

  useEffect(() => {
    // https://pt.stackoverflow.com/questions/1386/express%C3%A3o-regular-
    const emailPattern = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;
    setInactiveSubmission(
      !(formContact.name.length > 0
      && formContact.message.length > 0
      && emailPattern.test(formContact.email))
    )
  },[inactiveSubmission, formContact]);

  function handleSubmit(event) {
    event.preventDefault();
    emailjs.sendForm(
      'service_kyufxlm',
      'template_2mfaq2z',
      event.target,
      'user_Jc5xhOSE2eEEHPF99j1Ox',
    )
      .then((result) => {
        window.alert('Sua mensagem foi enviada.');
        clearFormContact();
        setInactiveSubmission(true);
        event.target.reset();
      }, (error) => {
        window.alert('O envio da mensagem falhou. Tente novamente.');
      });
  }

  function handleChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    setFormContact({
      ...formContact,
      [name]: value,
    });
  }

  function clearFormContact() {
    setFormContact({
      name: '',
      email: '',
      message: ''
    });
  }

  return (
    <section>
      <form
        className="contact-form"
        action="mailto:fjb.developer@gmail.com"
        method="post"
        encType='text/plain'
        onSubmit={ handleSubmit }
      >
        <input
          type="text"
          placeholder="Nome"
          name="name"
          onChange={ handleChange }
        />
        <input
          type="email"
          placeholder="Email"
          name="email"
          onChange={ handleChange }
        />
        <textarea
          placeholder="Escreva aqui sua mensagem"
          rows="10"
          columns="100"
          name="message"
          onChange={ handleChange }
        />
        <button
          className={
            inactiveSubmission
            ? 'submit-button submit-button-inactive'
            : 'submit-button submit-button-active'
          }
          type="submit"
          value="Submit"
          disabled={ inactiveSubmission }
        >
          Enviar
        </button>
      </form>
    </section>
  )
}

export default Form;
